import React, { useState, useContext } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { articles } from '../data/articles';
import { S3_HOSTNAME } from '../constant/hostname';
import { LanguageContext } from '../contexts/LanguageProvider';
import { LANGUAGES } from '../constant/languages';

interface Article {
  title: string;
  titleEn: string;
  url: string;
  createdAt: string;
}

const ArticleList: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const articlesPerPage: number = 5;
  const { language } = useContext(LanguageContext);
  const isJa = language === LANGUAGES.JA;

  // createdAtを元に記事を新しい順にソート
  const sortedArticles = articles.sort(
    (a: Article, b: Article) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  const indexOfLastArticle: number = currentPage * articlesPerPage;
  const indexOfFirstArticle: number = indexOfLastArticle - articlesPerPage;
  const currentArticles: Article[] = sortedArticles.slice(indexOfFirstArticle, indexOfLastArticle);
  const totalPages: number = Math.ceil(articles.length / articlesPerPage);

  const handleClick = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="mt-10">
      <h2 className="text-2xl font-bold mb-4">{isJa ? "記事一覧" : "Articles"}</h2>
      <div className="space-y-2 text-gray-700">
        {currentArticles.map((article, index) => (
          <div key={index} className="flex justify-between items-center bg-gray-50 p-2 rounded shadow">
            <span>{isJa ? article.title : article.titleEn}</span>
            <a href={S3_HOSTNAME + article.url} download target="_blank" rel="noopener noreferrer" className="ml-2 p-2 bg-green-500 text-white rounded hover:bg-green-400 transition duration-300 flex items-center">
              <ArrowDownTrayIcon className="h-5 w-5" aria-hidden="true" />
            </a>
          </div>
        ))}
      </div>

      <div className="flex justify-center space-x-2 mt-4">
        <button className={`px-3 py-1 border ${currentPage === 1 ? 'text-gray-400' : 'text-green-500'} rounded`} onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
          {isJa ? "前へ" : "Before"}
        </button>
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} className={`px-3 py-1 border ${currentPage === i + 1 ? 'bg-green-500 text-white' : 'bg-white text-green-500'} rounded`} onClick={() => handleClick(i + 1)}>
            {i + 1}
          </button>
        ))}
        <button className={`px-3 py-1 border ${currentPage === totalPages ? 'text-gray-400' : 'text-green-500'} rounded`} onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
          {isJa ? "次へ" : "After"}
        </button>
      </div>
    </div>
  );
};

export default ArticleList;
